/* Healthy Brain PDP behaviour. No dependencies; hb-motion.js (window.HBMotion) is optional. */
(function () {
  const reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initRoot(root) {
    const $ = (s, r) => (r || root).querySelector(s);
    const $$ = (s, r) => Array.from((r || root).querySelectorAll(s));
    let data = {};
    try { data = JSON.parse($('[data-hb-data]').textContent); } catch (e) {}
    const cur = data.currency || '£';
    const money = c => cur + (c / 100).toFixed(2);
    const variants = data.variants || [];
    const custom = String(data.two || '').trim().toLowerCase();
    const isTwo = v => { const t = (v.title || '').toLowerCase(); return (custom && custom !== '2' && t.includes(custom)) || /(^|[^0-9])2([^0-9]|$)|\btwo\b|\bx\s*2\b|\b180\b|\bdouble\b/.test(t); };
    const byId = id => id && variants.find(v => String(v.id) === String(id).trim());
    const vTwo = variants.find(isTwo) || byId(data.v2);
    const vOne = variants.find(v => v !== vTwo && !isTwo(v)) || [byId(data.v1)].find(v => v && v !== vTwo) || variants.find(v => v !== vTwo);
    const pickPlan = (v, want, days) => { const all = (v && v.plans) || []; const app = String(data.app || '').toLowerCase(); const pref = app ? all.filter(p => String(p.app || '').toLowerCase().includes(app)) : []; const ps = pref.length ? pref : all; if (want) { const w = all.find(p => String(p.id) === String(want).trim()); if (w) return w; } return ps.find(p => want && String(p.id) === String(want).trim()) || ps.find(p => new RegExp('\\b' + days + '\\b').test(p.name || '')) || ps[0]; };

    try {
    /* ---------- Buy box ---------- */
    const state = { size: vTwo ? 2 : 1, sub: true };
    const form = $('[data-hb-form]');
    if (!vTwo || !vOne || vTwo === vOne) { state.size = vTwo && !vOne ? 2 : 1; const w = $('[data-hb-sizewrap]'); if (w) w.hidden = true; }
    window.HB_PDP_DEBUG = { variants, oneBottle: vOne && vOne.id, twoBottles: vTwo && vTwo.id };
    const cartCfg = () => window.HBCart && HBCart.config({ vOne, vTwo, p1: vOne && pickPlan(vOne, data.p1, 45), p2: vTwo && pickPlan(vTwo, data.p2, 90) });
    cartCfg(); document.addEventListener('hb:cart-ready', cartCfg);
    function render() {
      const v = (state.size === 2 ? vTwo : vOne) || vOne || vTwo || variants[0];
      if (!v) return;
      const plan = state.size === 2 ? pickPlan(v, data.p2, 90) : pickPlan(v, data.p1, 45);
      if (!plan) state.sub = false;
      const subWrap = $('[data-hb-subwrap]'); if (subWrap) subWrap.hidden = !plan;
      const days = state.size === 2 ? 90 : 45;
      $('[data-hb-id]').value = v.id;
      $('[data-hb-plan]').value = state.sub && plan ? plan.id : '';
      $$('[data-hb-size]').forEach(b => b.setAttribute('aria-checked', String(+b.dataset.hbSize === state.size)));
      const sw = $('[data-hb-subwrap]'), one = $('[data-hb-pick="one"]'), subBtn = $('[data-hb-pick="sub"]');
      sw && sw.classList.toggle('is-on', state.sub); one && one.classList.toggle('is-on', !state.sub);
      subBtn && subBtn.setAttribute('aria-checked', String(state.sub)); one && one.setAttribute('aria-checked', String(!state.sub));
      const set = (s, t) => { const el = $(s); if (el) el.textContent = t; };
      const base = vOne ? vOne.price * (state.size === 2 ? 2 : 1) : 0;
      const was = Math.max(v.compare || 0, state.size === 2 ? base : 0);
      set('[data-hb-one]', money(was > v.price ? was : v.price)); set('[data-hb-one2]', money(v.price));
      const ow = $('[data-hb-onewas]'); if (ow) { ow.hidden = !(was > v.price); ow.textContent = money(was); }
      if (plan) { const pct = Math.round((1 - plan.price / v.price) * 100); set('[data-hb-pct]', 'SAVE ' + pct + '%'); set('[data-hb-pct2]', pct + '% off every order'); set('[data-hb-sub]', money(plan.price)); set('[data-hb-day]', Math.round(plan.price / days) + 'p a day'); }
      set('[data-hb-ships]', state.size === 2 ? '180 capsules, ships every 90 days' : '90 capsules, ships every 45 days');
      set('[data-hb-supply]', state.size === 2 ? '180 capsules · 90-day supply · 2 per day' : '90 capsules · 45-day supply · 2 per day');
      set('[data-hb-cta-l]', state.sub ? 'Subscribe & save' : 'Add to basket');
      set('[data-hb-cta-p]', money(state.sub && plan ? plan.price : v.price));
      const fs = $('[data-hb-freeship]'); if (fs) fs.hidden = !state.sub;
      const cta = $('[data-hb-cta]'); if (cta) { cta.disabled = !v.available; cta.toggleAttribute('data-soldout', !v.available); if (!v.available) set('[data-hb-cta-l]', 'Sold out'); }
    }
    $$('[data-hb-size]').forEach(b => b.addEventListener('click', () => { state.size = +b.dataset.hbSize; render(); }));
    $$('[data-hb-pick]').forEach(b => b.addEventListener('click', ev => { ev.preventDefault(); ev.stopPropagation(); state.sub = b.dataset.hbPick === 'sub'; render(); }));
    const swc = $('[data-hb-subwrap]'); if (swc) { swc.style.cursor = 'pointer'; swc.addEventListener('click', () => { if (!state.sub) { state.sub = true; render(); } }); }
    const root0 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    let busy = false;
    /* Meta Pixel: the subscribe button was only reported as "Subscribe". Also send a normal AddToCart for subscription adds.
       One-time adds are left alone (they already send AddToCart). */
    function trackSubAdd() {
      try {
        if (!state.sub || typeof window.fbq !== 'function') return;
        const v = (state.size === 2 ? vTwo : vOne) || vOne || vTwo || variants[0]; if (!v) return;
        const plan = state.size === 2 ? pickPlan(v, data.p2, 90) : pickPlan(v, data.p1, 45); if (!plan) return;
        const id = String(v.id), cu = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
        fbq('track', 'AddToCart', { content_type: 'product', content_ids: [id], contents: [{ id: id, quantity: 1 }], content_name: document.title, value: plan.price / 100, currency: cu }, { eventID: 'atc_sub_' + id + '_' + Date.now() });
      } catch (e) {}
    }
    function addToCart(e) {
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      if (busy || !form) return; busy = true;
      const planIn = $('[data-hb-plan]'); planIn.disabled = !planIn.value;
      if (window.HBCart && window.fetch) {
        const item = { id: +$('[data-hb-id]').value, quantity: 1 };
        if (planIn.value) item.selling_plan = +planIn.value;
        fetch(root0 + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) })
          .then(r => { if (!r.ok) throw r; trackSubAdd(); return HBCart.open(); })
          .catch(() => { submitForm(); })
          .finally(() => { busy = false; planIn.disabled = false; });
        return;
      }
      submitForm();
    }
    function submitForm() {
      trackSubAdd();
      const planIn = $('[data-hb-plan]'); planIn.disabled = !planIn.value;
      let rt = form.querySelector('input[name="return_to"]'); if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
      rt.value = root0 + 'cart';
      form.setAttribute('action', root0 + 'cart/add'); form.setAttribute('method', 'post');
      HTMLFormElement.prototype.submit.call(form);
      setTimeout(() => { busy = false; planIn.disabled = false; }, 3000);
    }
    if (form) form.addEventListener('submit', addToCart, true);
    window.addEventListener('pageshow', () => { busy = false; const pi = $('[data-hb-plan]'); if (pi) pi.disabled = false; render(); });
    const ctaBtn = $('[data-hb-cta]'); if (ctaBtn) ctaBtn.addEventListener('click', addToCart, true);
    render();
    if (vTwo && vOne) { const full = vOne.price * 2, save = full - vTwo.price; const bd = $('[data-hb-2badge]'); if (bd && save > 0) bd.textContent = 'SAVE ' + Math.round(save / full * 100) + '%'; }
    /* lowest per-day subscription price + headline discount, from real Shopify/Recharge prices */
    (function () {
      let minDay = Infinity, pct = 0;
      [[vOne, 45, data.p1], [vTwo, 90, data.p2]].forEach(([v, days, want]) => { if (!v) return; const p = pickPlan(v, want, days); if (!p) return; minDay = Math.min(minDay, p.price / days); pct = Math.max(pct, Math.round((1 - p.price / v.price) * 100)); });
      if (isFinite(minDay)) $$('[data-hb-minday]').forEach(el => { el.textContent = Math.round(minDay) + 'p'; });
      if (pct) $$('[data-hb-pct3]').forEach(el => { el.textContent = pct + '%'; });
      // hide any subscription widget injected by an app into our form; ours does the job
      setTimeout(() => form && form.querySelectorAll('.rc-widget, .rc-container-wrapper, [data-rc-widget], .recharge-subscription-widget').forEach(w => { w.style.display = 'none'; }), 1500);
    })();

    } catch (e) { console.error('[hb] Buy box', e); }
    /* ---------- Countdown: next dispatch cut-off (12:00 UK, weekdays only) ---------- */
    try {
      const cdEl = $('[data-hb-cd]'), cdDay = $('[data-hb-cd-day]');
      const CUT = 12 * 3600;
      const holidays = String(data.holidays || '').split(/[\s,]+/).filter(Boolean);
      const fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
      const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const iso = t => new Date(t).toISOString().slice(0, 10);
      const working = t => { const w = new Date(t).getUTCDay(); return w !== 0 && w !== 6 && !holidays.includes(iso(t)); };
      const nextWorking = t => { do { t += 864e5; } while (!working(t)); return t; };
      const p2 = n => String(n).padStart(2, '0');
      const tick = () => {
        const g = {}; fmt.formatToParts(new Date()).forEach(p => { g[p.type] = +p.value; });
        const today = Date.UTC(g.year, g.month - 1, g.day), now = (g.hour % 24) * 3600 + g.minute * 60 + g.second;
        const cutDay = working(today) && now < CUT ? today : nextWorking(today);
        const left = Math.max(0, Math.round((cutDay - today) / 1000) + CUT - now);
        const deliver = nextWorking(cutDay), daysAway = Math.round((deliver - today) / 864e5);
        if (cdEl) cdEl.textContent = p2(Math.floor(left / 3600)) + ':' + p2(Math.floor(left % 3600 / 60)) + ':' + p2(left % 60);
        if (cdDay) cdDay.textContent = 'free delivery ' + (daysAway === 1 ? 'tomorrow' : 'on ' + DAYS[new Date(deliver).getUTCDay()]);
      };
      tick(); setInterval(tick, 1000);
    } catch (e) { console.error('[hb] countdown', e); }

    try {
    /* ---------- Carousel ---------- */
    const car = $('[data-hb-car]');
    if (car) {
      const track = $('.hb-car__track', car), slides = $$('.hb-slide', track), N = slides.length;
      const strip = $('.hb-car__thumbs', car), count = $('.hb-car__count', car), vp = $('.hb-car__vp', car);
      const labels = ['Benefits', 'Key ingredients', 'How to use', 'Expert', 'Results', 'Nothing hidden', 'Label'];
      let i = 0;
      slides.forEach((s, k) => {
        const b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', (k + 1) + '. ' + (labels[k] || 'Image'));
        const d = document.createElement('div'); const c = s.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.setAttribute('inert', ''); c.querySelectorAll('[id]').forEach(n => n.removeAttribute('id'));
        d.appendChild(c); b.appendChild(d); b.addEventListener('click', () => go(k)); strip.appendChild(b);
      });
      const thumbs = $$('button', strip);
      function go(n) {
        i = ((n % N) + N) % N;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
        slides.forEach((s, k) => s.setAttribute('aria-hidden', String(k !== i)));
        thumbs.forEach((t, k) => t.setAttribute('aria-selected', String(k === i)));
        if (count) count.textContent = (i + 1) + ' / ' + N;
        const t = thumbs[i]; if (t) strip.scrollTo({ left: t.offsetLeft - strip.clientWidth / 2 + t.offsetWidth / 2, behavior: 'smooth' });
      }
      $('.prev', car).addEventListener('click', () => go(i - 1));
      $('.next', car).addEventListener('click', () => go(i + 1));
      vp.addEventListener('keydown', e => { if (e.key === 'ArrowLeft') go(i - 1); if (e.key === 'ArrowRight') go(i + 1); });
      let sx = null;
      vp.addEventListener('pointerdown', e => { sx = e.target.closest('button') ? null : e.clientX; });
      vp.addEventListener('pointerup', e => { if (sx == null) return; const d = e.clientX - sx; sx = null; if (Math.abs(d) > 40) go(i + (d < 0 ? 1 : -1)); });
      go(0);
    }

    } catch (e) { console.error('[hb] Carousel', e); }
    try {
    /* ---------- Tabs ---------- */
    const tabs = $('[data-hb-tabs]');
    if (tabs) {
      const tb = $$('[role="tab"]', tabs), panels = $$('[role="tabpanel"]', tabs);
      tb.forEach((b, k) => b.addEventListener('click', () => { tb.forEach((x, j) => x.setAttribute('aria-selected', String(j === k))); panels.forEach((p, j) => { p.hidden = j !== k; }); }));
    }

    } catch (e) { console.error('[hb] Tabs', e); }
    try {
    /* ---------- Single-open accordions ---------- */
    function single(container, btnSel, bodyOf) {
      if (!container) return;
      const btns = $$(btnSel, container);
      btns.forEach(b => b.addEventListener('click', () => {
        const open = b.getAttribute('aria-expanded') === 'true';
        btns.forEach(x => { x.setAttribute('aria-expanded', 'false'); bodyOf(x).hidden = true; });
        if (!open) { b.setAttribute('aria-expanded', 'true'); bodyOf(b).hidden = false; }
        if (b.dataset.img) { const im = $('[data-hb-ingimg]'), cap = $('[data-hb-ingcap]'); if (im && !open) { im.style.opacity = 0; setTimeout(() => { im.src = b.dataset.img; im.alt = b.dataset.name; im.style.opacity = 1; }, 150); } if (cap && !open) cap.textContent = b.dataset.name; }
      }));
    }
    single($('[data-hb-accs]'), '.hb-acc__btn', b => b.nextElementSibling);
    single($('[data-hb-faq]'), '.hb-faq__btn', b => b.nextElementSibling);
    single($('[data-hb-ings]'), '.hb-ing__btn', b => b.nextElementSibling);
    const more = $('[data-hb-benmore]');
    if (more) more.addEventListener('click', () => { const w = more.parentElement, on = !w.classList.contains('show-all'); w.classList.toggle('show-all', on); more.setAttribute('aria-expanded', String(on)); more.textContent = on ? 'Show less ↑' : 'Show more ↓'; });

    } catch (e) { console.error('[hb] block', e); }
    try {
    /* ---------- Who it's for ---------- */
    const who = $('[data-hb-who]');
    if (who) {
      const chips = $$('.hb-chip', who), items = $$('.hb-eff__item'), title = $('[data-hb-efftitle]');
      chips.forEach(c => c.addEventListener('click', () => {
        c.setAttribute('aria-pressed', String(c.getAttribute('aria-pressed') !== 'true'));
        const sel = chips.filter(x => x.getAttribute('aria-pressed') === 'true').map(x => x.dataset.k);
        items.forEach(it => { it.hidden = sel.length > 0 && !sel.includes(it.dataset.k); });
        if (title) title.textContent = sel.length ? 'WHAT THIS DOES TO THE BRAIN' : 'HOW EACH ONE AFFECTS THE BRAIN · SELECT ABOVE TO FILTER';
      }));
    }

    } catch (e) { console.error('[hb] Who its for', e); }
    try {
    /* ---------- Ingredients modal ---------- */
    const modal = $('[data-hb-modal]');
    if (modal) {
      const host = document.createElement('div'); host.className = 'hb'; host.style.cssText = 'background:none;position:static;height:0'; host.appendChild(modal); document.body.appendChild(host);
      let last = null;
      const dlg = modal.querySelector('[role="dialog"]');
      const open = e => { e.preventDefault(); e.stopPropagation(); last = e.currentTarget; modal.hidden = false; modal.style.display = 'grid'; document.documentElement.style.overflow = 'hidden'; dlg.focus(); };
      const close = () => { modal.hidden = true; modal.style.display = ''; document.documentElement.style.overflow = ''; last && last.focus(); };
      $$('[data-hb-open-ing]').forEach(b => b.addEventListener('click', open));
      root.addEventListener('click', e => { const b = e.target.closest && e.target.closest('[data-hb-open-ing]'); if (b && modal.hidden) open({ currentTarget: b, preventDefault() {}, stopPropagation() {} }); });
      modal.querySelector('[data-hb-close]').addEventListener('click', close);
      modal.addEventListener('click', e => { if (e.target === modal) close(); });
      document.addEventListener('keydown', e => {
        if (modal.hidden) return;
        if (e.key === 'Escape') close();
        if (e.key === 'Tab') { const f = Array.from(dlg.querySelectorAll('button,a[href]')); if (!f.length) return; const a = f[0], z = f[f.length - 1]; if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); } else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); } }
      });
    }

    } catch (e) { console.error('[hb] Ingredients modal', e); }
    try {
    /* ---------- Results count-up ---------- */
    const res = $('[data-hb-res]');
    if (res && 'IntersectionObserver' in window && !reduce && !res.__hbCount) { res.__hbCount = 1;
      const nums = $$('[data-count]', res); nums.forEach(n => { n.textContent = '0%'; });
      const io = new IntersectionObserver(es => {
        if (!es[0].isIntersecting) return; io.disconnect();
        const t0 = performance.now(), dur = 1600;
        const step = now => { nums.forEach((n, k) => { const q = Math.min(1, Math.max(0, (now - t0 - k * 150) / dur)); n.textContent = Math.round(+n.dataset.count * (1 - Math.pow(1 - q, 3))) + '%'; }); if (now - t0 < dur + 400) requestAnimationFrame(step); };
        requestAnimationFrame(step);
      }, { threshold: 0.4 });
      io.observe(res);
    }

    } catch (e) { console.error('[hb] block', e); }
    try {
    /* ---------- Marquee + bottle float ---------- */
    const mq = $('[data-hb-mq]'), diff = $('[data-hb-diff]'), bottle = $('[data-hb-bottle]');
    if (!reduce) {
      let x = 0, last = performance.now();
      const loop = now => {
        if (mq && !mq.__hbDur) { mq.__hbDur = 1; const half = mq.scrollWidth / 2; if (half) mq.style.animationDuration = (half / 50).toFixed(1) + 's'; }
        if (bottle && diff) { const r = diff.getBoundingClientRect(), vh = innerHeight; if (r.bottom > 0 && r.top < vh) { const e = Math.min(1, Math.max(0, (vh - r.top) / (vh * 0.7))), k = e * e * (3 - 2 * e); bottle.style.transform = 'translateY(' + ((1 - k) * 50 + Math.sin(now / 1400) * 6).toFixed(1) + 'px) scale(' + (0.9 + 0.1 * k).toFixed(3) + ')'; } }
        last = now; requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    }

    } catch (e) { console.error('[hb] Marquee + bottle float', e); }
    try {
    /* ---------- Particle field ---------- */
    const canvas = $('[data-hb-canvas]'), diff = $('[data-hb-diff]');
    if (canvas && diff) {
      let n = 0;
      const start = () => {
        const M = window.HBMotion; if (!M) { if (++n < 50) setTimeout(start, 100); return; }
        const P = [69, 36, 127], V = [107, 75, 166];
        const ph = (layout, o) => Object.assign({ layout, line: 0.2, draw: 1, dot: 0.8, leaf: 0, drift: 5, col: P }, o);
        const prog = () => { const r = diff.getBoundingClientRect(), vh = innerHeight; return M.clamp((vh - r.top) / (vh + r.height * 0.4)); };
        M.field(canvas, {
          count: 84, pointer: true, seed: 21, maxDist: 120, reduced: reduce, progress: prog,
          exclude: (w, h) => ({ x: w / 2, y: h / 2, r: Math.min(w, h) * 0.3 }),
          phases: [ph(M.L.scatter(), { line: 0.18, dot: 0.75, drift: 8, col: V }), ph(M.L.ring(0.5, 0.5, 0.4), { line: 0.42, dot: 0.9, leaf: 0.9, drift: 7, col: V }), ph(M.L.ring(0.5, 0.5, 0.44), { line: 0.3, dot: 0.8, leaf: 0.7, drift: 10, col: V })]
        });
      };
      start();
    }
    } catch (e) { console.error('[hb] Particle field', e); }
  }

  const boot = () => document.querySelectorAll('[data-hb-pdp]').forEach(r => { if (!r.__hb) { r.__hb = 1; try { initRoot(r); } catch (e) { console.error('[hb] init', e); } r.setAttribute('data-hb-ready', '1'); console.info('[hb] PDP ready', window.HB_PDP_DEBUG || ''); } });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
